import { endPoints } from 'api/';
import { GET_ATTRIBUTE } from 'actions/types';

/**
 * @description Get a list of all attributes
 * @param {string} companyId Current user's company id.
 * @returns Array of attribute objects
 */
function query(companyId) {
  const query = {
    where: {
      company_id: companyId,
      entity_type: 'inventory',
    },
  };

  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: GET_ATTRIBUTE,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        const attributes = await apiClient(endPoints.GET_ATTRIBUTE, {}, query);
        return attributes;
      },
    };
    dispatch(action);
  };
}

export default query;
